import { render, staticRenderFns } from "./PlaylistModal.vue?vue&type=template&id=05571864&scoped=true&"
import script from "./PlaylistModal.vue?vue&type=script&lang=js&"
export * from "./PlaylistModal.vue?vue&type=script&lang=js&"
import style0 from "./PlaylistModal.vue?vue&type=style&index=0&id=05571864&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05571864",
  null
  
)

export default component.exports